import styled, { css } from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  width: 100%;
  height: 100%;

  background: #fbfbfb;
`;

export const WiseServices = styled.span`
  font-size: 24px;
  padding-top: 30px;
  margin-bottom: 32px;
`;

export const Offerings = styled.div`
  width: 100%;
  max-width: 650px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const Offer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 10px 0px 20px 0px;

  span {
    width: 100%;
    max-width: 370px;
    color: #7a7a7a;
    font-size: 16px;
    text-align: left;
    text-overflow: ellipsis;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 30%;
  height: 100%;

  @media (max-width: 1580px) {
    width: 50%;
  }

  @media (max-width: 1300px) {
    width: 70%;
    min-width: 430px;
  }

  @media (max-width: 700px) {
    width: 100%;
    min-width: 300px;

    #logoV4H {
      width: 100%;
    }
  }
`;

export const Title = styled.p`
  font-weight: 700;
  font-size: 24px;
  color: #444a51;

  margin-bottom: 8px;
`;

export const Form = styled.form`
  display: flex;
  width: 480px;
  height: fit-content;
  flex-direction: column;
  padding: 24px 36px;
  background: white;
  border: 1px solid #efefef;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  gap: 16px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;
  gap: 8px;
`;

export const Header = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /*   height: auto; */
`;

export const Body = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  /* max-width: 1080px; */

  align-items: center;
  justify-content: center;
  gap: 64px;

  .text {
    width: 90%;
    padding-top: 30px;
    font-weight: 400;
    font-size: 24px;
    line-height: 42px;
    color: #7a7a7a;
  }
`;

const SizeVariant = css`
  text-decoration: none;
  color: ${props => props.theme.primary};
  cursor: pointer;
  :hover {
    color: ${shade(0.2, '#1756E8')};
  }
`;

export const SignUp = styled.a`
  ${SizeVariant};
  font-weight: bold;
  font-size: 18px;
`;

export const Image = styled.img`
  margin-right: 2px;
`;

export const ImageContainer = styled.div`
  display: flex;
`;
